import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <g className="icon-color">
          <path
            fillRule="nonzero"
            d="M1 0h4c.552 0 1 .448 1 1v4c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1zm1 2v2h2V2H2zM9 8h4c.552 0 1 .448 1 1v4c0 .552-.448 1-1 1H9c-.552 0-1-.448-1-1V9c0-.552.448-1 1-1zm1 2v2h2v-2h-2zM11 6c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm0-1.9c-.607 0-1.1-.492-1.1-1.1 0-.608.493-1.1 1.1-1.1.608 0 1.1.492 1.1 1.1 0 .608-.492 1.1-1.1 1.1z"
            transform="translate(1 1)"
          />
          <path
            d="M1.641 10.999L.281 9.638c-.375-.373-.375-.984 0-1.357.373-.374.984-.374 1.358 0l1.36 1.36 1.361-1.36c.373-.374.984-.374 1.357 0 .375.373.375.984 0 1.357l-1.36 1.36 1.36 1.362c.375.374.375.984 0 1.358-.372.374-.983.374-1.356 0l-1.362-1.362-1.361 1.362c-.374.374-.984.374-1.358 0-.373-.374-.373-.984 0-1.358l1.361-1.361z"
            transform="translate(1 1)"
          />
        </g>
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <g className="icon-color">
          <path
            fillRule="nonzero"
            d="M2 0h5c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2H2C.895 9 0 8.105 0 7V2C0 .895.895 0 2 0zm0 2v5h5V2H2zM13 11h5c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-5c-1.105 0-2-.895-2-2v-5c0-1.105.895-2 2-2zm0 2v5h5v-5h-5zM15.5 9C17.985 9 20 6.985 20 4.5S17.985 0 15.5 0 11 2.015 11 4.5 13.015 9 15.5 9zm0-2C14.12 7 13 5.88 13 4.5S14.12 2 15.5 2 18 3.12 18 4.5 16.88 7 15.5 7z"
            transform="translate(2 2)"
          />
          <path
            d="M4.501 16.859l-2.865 2.865c-.372.372-.98.372-1.353 0l-.004-.005c-.372-.372-.372-.981 0-1.354L3.143 15.5.28 12.637c-.372-.372-.372-.981 0-1.353l.004-.005c.373-.372.98-.372 1.353 0L4.5 14.143l2.864-2.864c.372-.372.981-.372 1.353 0l.005.005c.372.372.372.98 0 1.353L5.86 15.5l2.865 2.864c.372.373.372.982 0 1.354l-.005.005c-.372.372-.981.372-1.353 0L4.5 16.859z"
            transform="translate(2 2)"
          />
        </g>
      </g>
    </svg>
  ),
};
